import * as yup from "yup";
import {
  optionalPasswordSchema,
  conditionalPasswordConfirmationSchema,
  requiredPasswordSchema,
} from "utils/passwordValidation.js";

// Validation schema for the admin user form
// Helper to normalize empty strings to null for optional text fields
const emptyToNull = (v) => (v === "" ? null : v);

export const userValidationSchema = yup.object({
  rolle: yup.string().required("Bitte wählen Sie eine Rolle aus."),
  status: yup.string().required("Bitte wählen Sie einen Status aus."),
  kunde_id_ov: yup.mixed().when("rolle", {
    is: (rolle) =>
      rolle !== "sysadmin" &&
      rolle !== "makler_sachbearbeitung" &&
      rolle !== "makler_buchhaltung",
    then: () => yup.mixed().required("Bitte wählen Sie einen Kunden aus."),
    otherwise: () => yup.mixed().nullable(),
  }),
  email: yup
    .string()
    .email("Bitte geben Sie eine gültige E-Mail-Adresse ein.")
    .required("E-Mail ist erforderlich."),
  telefon: yup.string().nullable().transform(emptyToNull),
  fax: yup.string().nullable().transform(emptyToNull),
  anrede: yup.string().nullable().transform(emptyToNull),
  titel: yup.string().nullable().transform(emptyToNull),
  vorname: yup.string().required("Vorname ist erforderlich."),
  nachname: yup.string().required("Nachname ist erforderlich."),
  strasse: yup.string().nullable().transform(emptyToNull),
  plz: yup.string().nullable().transform(emptyToNull),
  ort: yup.string().nullable().transform(emptyToNull),
  password: yup.string().when("$isEditMode", {
    is: false,
    then: () => requiredPasswordSchema,
    otherwise: () => optionalPasswordSchema,
  }),
  password_repetition: conditionalPasswordConfirmationSchema("password"),
  rpp: yup.string(),
  level_benachrichtigung: yup.string(),
});

// Default values for the form
export const userDefaultValues = {
  rolle: "",
  status: "aktiv",
  kunde_id_ov: null,
  email: "",
  telefon: "",
  fax: "",
  anrede: "",
  titel: "",
  vorname: "",
  nachname: "",
  strasse: "",
  plz: "",
  ort: "",
  password: "",
  password_repetition: "",
  rpp: "5",
  level_benachrichtigung: "taeglich",
};

// Options for select fields
export const userOptions = {
  rolle: [
    { key: "sysadmin", label: "Systemadministrator" },
    { key: "makler_sachbearbeitung", label: "Makler (Sachbearbeitung)" },
    {
      key: "makler_buchhaltung",
      label: "Makler (Buchhaltung / Buchungsexport)",
    },
    { key: "kd_verwaltung", label: "Kunde (Verwaltung)" },
    { key: "kd_controlling", label: "Kunde (Controlling)" },
    { key: "kd_aussendienst", label: "Kunde (Aussendienst)" },
    {
      key: "kd_eingeschraenkt",
      label: "Kunde (Aussendienst eingeschränkt)",
    },
  ],
  status: [
    { key: "aktiv", label: "aktiv" },
    { key: "inaktiv", label: "inaktiv (Nutzer kann sich nicht anmelden)" },
    { key: "gesperrt", label: "gesperrt (Passwort vergessen möglich)" },
  ],
  anrede: [
    { key: "Herr", label: "Herr" },
    { key: "Frau", label: "Frau" },
  ],
  rpp: [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "20", label: "20" },
    { key: "25", label: "25" },
    { key: "30", label: "30" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
  ],
  level_benachrichtigung: [
    {
      key: "einzeln",
      label: "einzeln",
      detail: "Sie erhalten für jede Aktualisierung eine separate E-Mail.",
    },
    {
      key: "taeglich",
      label: "täglich",
      detail:
        "Bei Aktualisierungen erhalten Sie einmal am Tag eine Zusammenfassung per E-Mail.",
    },
    {
      key: "keine",
      label: "keine",
      detail:
        "Das Schadenportal sendet Ihnen keine E-Mails. Sie sollten sich deshalb regelmäßig im Schadenportal anmelden um keine Aktualisierung zu verpassen.",
    },
  ],
};

// API endpoints for fetching data
export const optionsApiEndpoints = {
  kundeOptions: "data/kundes_select",
};

// Helper function to check if a field should be disabled based on the role
export const isFieldDisabledByRole = (fieldName, role) => {
  if (fieldName === "kunde_id_ov") {
    return (
      role === "sysadmin" ||
      role === "makler_sachbearbeitung" ||
      role === "makler_buchhaltung"
    );
  }

  return false;
};

